<template>
    <Modal
        v-if="showModal"
        @modal:close="servicesNudgesStore.closeModal"
        :maxWidth="'max-w-[540px]'"
        :hideActions="true"
    >
        <template #body>
            <component :is="featureComponent"/>
        </template>
    </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useServicesNudges } from "../../store/services-nudges.store"

import Modal from "../../components/modal.vue";
import ResumAINudge from "./components/resume-nudge.vue"
import AutoApplyNudge from "./components/auto-apply-nudge.vue"

const servicesNudgesStore = useServicesNudges()
const { showModal, selectedFeature } = storeToRefs(servicesNudgesStore)

const FEATURE_NUDGE_MAP = {
    'resum_ai': ResumAINudge,
    'auto_apply': AutoApplyNudge
}

const featureComponent = computed(() => {
    return FEATURE_NUDGE_MAP[selectedFeature.value]
})
</script>
